// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"170":"css/app","773":"/js/app","898":"/js/vendor","929":"/js/manifest"}[chunkId] || chunkId) + ".css";
};